import React, { useContext, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import { useParams } from "react-router-dom";
import { SearchContext } from "@context/SearchContext";
import MapsMarkerIcon from "@components/Icons/MapsMarkerIcon";

const VenueInformation = () => {
    const { id, venue_name } = useParams();
    const { fetchVenue, venue } = useContext(SearchContext);
    const {
        address,
        city,
        description,
        email,
        latitude,
        longitude,
        name,
        phone,
        postcode,
        state,
        website,
    } = venue;
    const venueAddress = `${address}, ${city}, ${state}, ${postcode}`;
    useEffect(() => {
        if (id && venue_name) {
            fetchVenue(id, venue_name);
        }
    }, [id, venue_name, fetchVenue]);

    return (
        <div className="search-details-venue__tab-wrapper">
            <div className="search-details-venue__detail">
                <h2 className="search-details-venue__title">{name}</h2>
                <h3 className="search-details-venue__text">
                    {description}
                </h3>
                {venueAddress && <div className="search-details-venue__text">Address: <span
                    className="search-details-venue__text--field">{venueAddress}</span></div>}
                {website && <div className="search-details-venue__text">Website: <a href={website} target="_blank"
                    rel="noopener noreferrer"
                    className="search-details-venue__link">{website}</a>
                </div>}
                {phone && <div className="search-details-venue__text">Phone: <span
                    className="search-details-venue__text--field">{phone}</span></div>}
                {email && <div className="search-details-venue__text">Email: <span
                    className="search-details-venue__text--field">{email}</span></div>}
            </div>
            <div className="search-details-venue__map-wrap">
                {latitude && longitude && (
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: "AIzaSyC4N1BHxxWohTt7moat_Mq3x5Gw5U6Cvqw" }}
                        className="map"
                        yesIWantToUseGoogleMapApiInternals
                        region="au"
                        zoom={11}
                        center={{ lat: Number(latitude), lng: Number(longitude) }}
                    >
                        <MapsMarkerIcon lat={latitude} lng={longitude} className="venue__marker" />
                    </GoogleMapReact>
                )}
            </div>
        </div>
    );
};

export default VenueInformation;
